function NewComponents() {
    return ( 
        <div>
            New Component
        </div>
     );
}

export default NewComponents;